module.exports = __webpack_public_path__ + "static/media/6_r_bar_80.57_11.02.d856a3b9.png";